import React from 'react';
import {styled} from '@mui/material/styles';

import MUIButton from '@mui/material/Button';

const Button = styled(props => (
  <MUIButton variant="contained" size="small" {...props} />
))(({theme, ...props}) => ({
  alignSelf: 'center',
  fontSize: 10,
  textTransform: 'none',
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: '#ADB5B6',
  },
  outline: 0,
  '& span': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  color: props.active
    ? theme.palette.primary.main
    : theme.palette.text.secondary,
}));

export default Button;
